import { ambiente } from "../../shared/utils/enum";
export const envConfig = {
  REACT_APP_NOME_AMBIENTE: ambiente.homologacao,
  PUBLIC_URL: "https://hml-iris.helpdeexames.com.br",
  REACT_APP_API_URL: "https://hml-api-iris.helpdeexames.com.br/api/v1/",
  REACT_APP_URL_PAGINA_INICIAL_MY_PARDINI:
    "http://jbossiris.hermespardini.com.br/mypardini/faces/pages/dashboard.xhtml",
  REACT_APP_CODIGO_GOOGLE_ANALYTICS: "UA-207528302-1",
  PUBLIC_URL_PARDINI_CANONICCAL: "https://psc.hermespardini.com.br"
};
